import api from './api'

/**
 * Fetch all published public events with optional filters
 * @param {Object} params - Query params: city, state_code, event_type, sort
 */
export const fetchPublicEvents = async (params = {}) => {
    // Remove empty string params
    const cleanParams = Object.fromEntries(
        Object.entries(params).filter(([, v]) => v !== '' && v != null)
    )
    const data = await api.get('/events', { params: cleanParams })
    return data
}

/**
 * Fetch a single event by ID
 * @param {string} id - Event ID
 */
export const fetchEventById = async (id) => {
    const data = await api.get(`/events/${id}`)
    return data
}

/**
 * Fetch city name suggestions for autocomplete
 * @param {string} query - Prefix to search (e.g. "gu")
 * @returns {Promise<string[]>} Array of matching city names (max 10)
 */
export const fetchCitySuggestions = async (query) => {
    const data = await api.get('/cities/suggestions', { params: { q: query } })
    return data
}
